module.exports = __webpack_public_path__ + "img/GabrielleNadeauArt-Blue-Monster-Teddy-Bear-Web-640.607bd0ca.png";